import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { RequestQuotationClientResponse } from '../@types/RequestQuotation'

type Store = {
  requestQuotation: RequestQuotationClientResponse | null
  setRequestQuotation: (value: RequestQuotationClientResponse) => void
  resetRequestQuotation: () => void
}

export const useRequestQuotationStore = create<Store>()(
  devtools(
    (set) => ({
      requestQuotation: null,
      setRequestQuotation: (requestQuotation) => set({ requestQuotation }),
      resetRequestQuotation: () => set({ requestQuotation: null }),
    }),
    { name: 'RequestQuotationStore' },
  ),
)
